
export const ADMIN_GET_REQUEST = 'ADMIN_GET_REQUEST';
export const ADMIN_LOGIN_REQUEST = 'ADMIN_GET_REQUEST';
export const ADMIN_LOGIN_SUCCESS = "ADMIN_LOGIN_SUCCESS"
export const ADMIN_LOGIN_FAILURE = "ADMIN_LOGIN_FAILURE"
